import React from 'react';
import PropTypes from 'prop-types';

const DialogButton = ({ analyticsValue, children, className }) => (
    <button
        className={className}
        onClick={event => {
            // Stop the page reloading
            event.preventDefault();

            window.dispatchEvent(
                new CustomEvent('setDialogOpen', { detail: { analyticsValue } })
            );
        }}
    >
        {children}
    </button>
);

DialogButton.propTypes = {
    analyticsValue: PropTypes.number,
    children: PropTypes.node.isRequired,
};

export default DialogButton;
